import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation, {
    ExistingUser,
    ReturnToProduct
} from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    Headings,
    PickUpWhereYouLeftOffText,
    SubHeading,
    WelcomeBackHeading,
    WelcomeBackText
} from "../../components";

export const CurrentProductUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const content = (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<WelcomeBackText />}
                    sub={<PickUpWhereYouLeftOffText />}
                />
            ) : (
                <>
                    <WelcomeBackHeading />
                    <SubHeading>
                        <PickUpWhereYouLeftOffText />
                    </SubHeading>
                </>
            )}
            {/* everyone with a teamwork collection should see a return to product experience */}
            <SiteActivation
                CurrentProductUser={
                    <ReturnToProduct
                        ExistingUser={<ExistingUser SitePicker={null} />}
                    />
                }
            />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
